import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';

const options = {
  name: 'pagerConfigurations',
  baseType: 'PAGER_CONFIGURATIONS',
  singularAssociation: true,
  apiEndpoint: 'pagers/{id}/configuration',
  // the loadedAt is a hack to force an update in Redux, thereby forcing Formik
  // in the OAPConfigurationForm to rerender with the new values
  transform: t => ({ ...t, id: t.pager_id, loadedAt: Math.round(Date.now()) })
};

const operations = createMetadataAPIOperations(options);
const selectors = createMetadataAPISelectors(options);

export { operations, selectors };
export default createMetadataAPIReducer(options);
